module.exports = __webpack_public_path__ + "static/media/molinera_selecta.aaf2ab1e.png";